var gql = require("graphql-tag");
module.exports = gql;
